var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPartnerWithSafe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1000007342"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 168",
    opacity: 0.5,
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#DBBEFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1000007346"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3809"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3811",
    d: "M20 34C12.8195 31.9218 8 26.2438 8 19.8626V11.4813C12.2686 11.4813 16.3624 10.0565 19.3807 7.52034L20 7L20.6193 7.52034C23.6376 10.0565 27.7314 11.4813 32 11.4813V19.8626C32 26.2438 27.1804 31.9218 20 34Z",
    stroke: "#B246FF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3797"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3799",
    d: "M26.2694 17.36L19.0027 23.4658L15.3694 20.4129",
    stroke: "#B246FF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartnerWithSafe);
export default __webpack_public_path__ + "static/media/partner-with-safe.22815991cd3a4e239b24403d63b37c8e.svg";
export { ForwardRef as ReactComponent };